import { CaseTypeFilterOptions } from '../../enums/filters-and-searchs/casetype.filter.options';

export const CaseTypeFilterOptionsDetail = new Map<number, string>([
    [CaseTypeFilterOptions.None, 'None'],
    [CaseTypeFilterOptions.Deleted, 'Deleted Case Types'],
]);
